import { ia, snakeToTitleCase } from 'lib/helpers/utility';
import {
  CARD_ON_FILE_REQUIRED_MESSAGE,
  LOW_ASSURANCE_RESPONSE_CODES
} from 'lib/constants/healthcareProgram/fields';

const MAX_DISPLAY_LENGTH = 120;
const BLOB_CHARACTERS = /[{}[\]"]/;
const CODE_STYLE = /^[A-Z0-9_ ]+$/;
const GENERIC_ERROR_MESSAGE = 'Payment failed';

export const toDisplayPaymentMessage = (raw, fallback) => {
  if (typeof raw !== 'string') return fallback;

  const message = raw.trim();
  if (!message || message.length > MAX_DISPLAY_LENGTH) return fallback;
  if (BLOB_CHARACTERS.test(message) || message === '[object Object]') return fallback;

  return CODE_STYLE.test(message) ? snakeToTitleCase(message.toLowerCase()) : message;
};

const toLine = (value) => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number') return String(value);
  if (!value || typeof value !== 'object') return '';

  return (
    toLine(value.message) ||
    toLine(value.error) ||
    toLine(value.description) ||
    toLine(value.reason) ||
    toLine(value.detail) ||
    ''
  );
};

const collectLines = (value) => {
  if (ia(value)) return value.flatMap(collectLines);

  if (value && typeof value === 'object') {
    const nested = value.errors || value.validationFailures || value.messages;
    if (ia(nested)) return nested.flatMap(collectLines);
  }

  const line = toLine(value);
  return line ? [line] : [];
};

export const normalizeErrorMessage = (message) => {
  if (message?.code === LOW_ASSURANCE_RESPONSE_CODES.CARD_ON_FILE_REQUIRED) {
    return [CARD_ON_FILE_REQUIRED_MESSAGE];
  }

  const lines = [
    ...new Set(collectLines(message).map((line) => toDisplayPaymentMessage(line, null)))
  ].filter(Boolean);

  return lines.length ? lines : [GENERIC_ERROR_MESSAGE];
};
